import { withCriticalRetry } from "@utils/apiWrapper";
import axios from "axios";
import { API_BASE_URL } from "initializers/constants";
const create = (ciBuildId, historyId, payload) => withCriticalRetry(() => axios.post(`${API_BASE_URL}/reporter/runs/${ciBuildId}/test_entities/${historyId}/attempts`, payload), { additionalRetryStatusCodes: [422] });
const update = ({ ciBuildId, historyId, id, payload, }) => withCriticalRetry(() => axios.put(`${API_BASE_URL}/reporter/runs/${ciBuildId}/test_entities/${historyId}/attempts/${id}`, payload), { additionalRetryStatusCodes: [422] });
const attemptsApi = { create, update };
export default attemptsApi;
//# sourceMappingURL=attempts.js.map